import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import {
    Box, Typography, Paper, Tabs, Tab, List, ListItem,
    ListItemText, CircularProgress, TextField, InputAdornment
} from '@mui/material';
import { formatDate } from '../utils';

const Reports = () => {
    const [tab, setTab] = useState(0);
    const [loading, setLoading] = useState(false);
    const [data, setData] = useState([]);
    const [minChildren, setMinChildren] = useState(5);

    useEffect(() => {
        setLoading(true);
        setData([]); // Clear data when changing tabs or parameters
        let url = '';
        if (tab === 0) url = '/api/reports/large-families?minChildren=' + minChildren;
        else if (tab === 1) url = '/api/reports/multiple-partners';
        else if (tab === 2) url = '/api/reports/multiple-partners-children';

        axios.get(url)
            .then(res => {
                setData(Array.isArray(res.data) ? res.data : []);
                setLoading(false);
            })
            .catch(err => {
                console.error('Error fetching reports:', err);
                setData([]);
                setLoading(false);
            });
    }, [tab, minChildren]);

    return (
        <Box sx={{ maxWidth: 800, mx: 'auto' }}>
            <Typography variant="h4" sx={{ fontWeight: 700, mb: 3 }}>
                Reportes Especiales
            </Typography>

            <Paper sx={{ mb: 3 }}>
                <Tabs value={tab} onChange={(e, v) => setTab(v)} variant="fullWidth">
                    <Tab label="Familias Numerosas" />
                    <Tab label="Múltiples Parejas" />
                    <Tab label="Parejas con Hijos" />
                </Tabs>
            </Paper>

            {tab === 0 && (
                <Box sx={{ mb: 2, display: 'flex', justifyContent: 'flex-end' }}>
                    <TextField
                        label="Mínimo de hijos"
                        type="number"
                        size="small"
                        value={minChildren}
                        onChange={(e) => setMinChildren(e.target.value)}
                        InputProps={{
                            startAdornment: <InputAdornment position="start">≥</InputAdornment>,
                        }}
                        sx={{ width: 150 }}
                    />
                </Box>
            )}

            {loading ? (
                <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
                    <CircularProgress />
                </Box>
            ) : (
                <Paper elevation={0} sx={{ border: '1px solid', borderColor: 'divider', borderRadius: 2 }}>
                    <List disablePadding>
                        {!Array.isArray(data) || data.length === 0 ? (
                            <ListItem><ListItemText primary="No se encontraron resultados" /></ListItem>
                        ) : (
                            data.map((person, index) => (
                                <ListItem
                                    key={person.id_person}
                                    component={Link}
                                    to={`/tree/${person.id_person}`}
                                    divider={index < data.length - 1}
                                    sx={{
                                        textDecoration: 'none',
                                        color: 'inherit',
                                        '&:hover': { bgcolor: 'rgba(62,44,28,0.05)' },
                                    }}
                                >
                                    <ListItemText
                                        primary={`${person.firstname} ${person.lastname}`}
                                        secondary={
                                            tab === 0 
                                                ? `${person.children_count} hijos` 
                                                : tab === 1
                                                    ? `${person.partner_count} parejas registradas`
                                                    : `${person.partner_count} parejas con hijos`
                                        }
                                        primaryTypographyProps={{ fontWeight: 500 }}
                                    />
                                    <Typography variant="body2" color="text.secondary">
                                        {[formatDate(person.birthday), formatDate(person.decease)].filter(Boolean).join(' — ')}
                                    </Typography>
                                </ListItem>
                            ))
                        )}
                    </List>
                </Paper>
            )}
        </Box>
    );
};

export default Reports;
